import React, { useEffect, useRef } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import gsap from 'gsap';

function Information() {
    const leftContentRef = useRef(null);
    const rightContentRef = useRef(null);
    const leftImageRef = useRef(null);
    const rightImageRef = useRef(null);

    useEffect(() => {
        // Animación de aparición de contenido izquierdo
        gsap.from(leftContentRef.current, {
            duration: 1.5,
            x: -100,
            ease: 'power4.out'
        });

        // Animación de aparición de imagen izquierda
        gsap.from(leftImageRef.current, {
            duration: 1.5,
            x: -100,
            ease: 'power4.out',
            delay: 0.5
        });

        // Animación de aparición de contenido derecho
        gsap.from(rightContentRef.current, {
            duration: 1.5,
            x: 100,
            ease: 'power4.out',
            delay: 1
        });

        // Animación de aparición de imagen derecha
        gsap.from(rightImageRef.current, {
            duration: 1.5,
            x: 100,
            ease: 'power4.out',
            delay: 1.5
        });
    }, []);

    return (
        <section id="information" className="py-5 bg-light">
            <Container>
                <Row className="justify-content-center mb-5">
                    <Col md={6} className="text-center" ref={leftContentRef}>
                        <h2>Comparte viajes y ahorra con Edudrive</h2>
                        <p>Conecta con estudiantes que viven cerca de ti y organiza viajes compartidos, ¡ahorra en transporte mientras fortaleces la comunidad universitaria!</p>
                        <Button variant="dark" size="lg">Comienza ahora</Button>
                    </Col>
                    <Col md={6}>
                        <div className="image-wrapper" ref={leftImageRef}>
                            <img src="/img1.png" alt="Viaje compartido" className="img-fluid" />
                        </div>
                    </Col>
                </Row>

                <Row className="justify-content-center mb-5">
                    <Col md={6}>
                        <div className="image-wrapper" ref={rightImageRef}>
                            <img src="/img3.jpg" alt="Transporte ecológico" className="img-fluid" />
                        </div>
                    </Col>
                    <Col md={6} className="text-center" ref={rightContentRef}>
                        <h2>Ahorra y viaja cómodamente</h2>
                        <p>Viajarás cómodamente y ahorrarás en transporte, obteniendo a una experiencia más económica y eficiente.</p>
                        <Button variant="dark" size="lg">Ver más detalles</Button>
                    </Col>
                </Row>

                <Row className="justify-content-center">
                    <Col md={6} className="text-center" ref={leftContentRef}>
                        <h2>Viajes seguros entre estudiantes</h2>
                        <p>En Edudrive, solo los estudiantes verificados pueden unirse a los viajes, garantizando la seguridad y confianza para todos los pasajeros.</p>
                        <Button variant="dark" size="lg">Reserva tu lugar</Button>
                    </Col>
                    <Col md={6}>
                        <div className="image-wrapper" ref={leftImageRef}>
                            <img src="/img2.png" alt="Viajes seguros" className="img-fluid" />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Information;
